import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { AppError, AuthenticationStatus, AuthSelector, MessageService } from "@obg/ngx.core";
import { merge, Observable, of } from "rxjs";
import { catchError, filter, map, switchMap, take, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { SUPPORT_ACTION_TYPE, SupportAction } from "./support.action";
import { SupportService } from "./support.service";

@Injectable()
export class SupportEffect {
	getLiveChatUrl$: Observable<Action> = createEffect(() =>
		this.actions$.pipe(
			ofType(SUPPORT_ACTION_TYPE.getLiveChatUrl),
			withLatestFrom(
				this.store.select(AuthSelector.getAuthenticationStatus).pipe(
					filter((authenticationStatus) => authenticationStatus !== AuthenticationStatus.Pending),
					take(1)
				)
			),
			switchMap(() =>
				this.service.getLiveChatUrl().pipe(
					map((result) => this.action.getLiveChatUrlSuccess(result)),
					catchError((error: AppError) => of(this.action.getLiveChatUrlFail(error)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[SUPPORT_ACTION_TYPE.getLiveChatUrlFail]: SUPPORT_ACTION_TYPE.getLiveChatUrl,
			}),
			this.messageService.mapClearByContext$({
				[SUPPORT_ACTION_TYPE.getLiveChatUrl]: SUPPORT_ACTION_TYPE.getLiveChatUrl,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: SupportAction,
		private service: SupportService,
		private messageService: MessageService,
		private store: Store<CommonState>
	) {}
}
